export type {
  CardPreviewSlots,
  CardPreviewBaseProps as CardPreviewProps,
  CardPreviewBaseState as CardPreviewState,
} from '@fluentui/react-card';
